<div class="ef-page">

  <div class="ef-header">
    <div class="ef-header__icon"><mat-icon>description</mat-icon></div>
    <div>
      <h1 class="ef-header__title">{{ form?.get('uid')?.value ? 'Editar presupuesto' : 'Nuevo presupuesto' }}</h1>
      <p class="ef-header__sub">{{ form?.get('uid')?.value ? 'Modifica los datos del presupuesto' : 'Crea un nuevo presupuesto para un cliente' }}</p>
    </div>

    <div class="cf-total-cards pf-header-totals" *ngIf="!isLoading && items.length > 0">
      <div class="cf-total-card">
        <p class="label">Subtotal <strong>{{ subtotal | number:'1.2-2' }} €</strong></p>
      </div>
      <div class="cf-total-card cf-total-card--highlight">
        <p class="label">Total <strong>{{ total | number:'1.2-2' }} €</strong></p>
      </div>
    </div>

    <div class="pf-header-actions">
      <button mat-stroked-button type="button" class="pf-btn-cancel" (click)="onCancel()" [disabled]="isSaving">
        <mat-icon>arrow_back</mat-icon> Volver
      </button>
      <button mat-flat-button class="ef-btn-save" (click)="onSave()" [disabled]="isSaving || isLoading">
        <mat-icon>save</mat-icon> Guardar
      </button>
    </div>
  </div>

  <div class="ef-body" *ngIf="!isLoading">
    <form [formGroup]="form" class="pf-form">

      <div class="pf-side-by-side">
        <mat-card appearance="outlined" class="tf-card">
          <mat-card-content>
            <div class="tf-section-header">
              <h6 class="tf-section-title">Cliente</h6>
            </div>

            <app-autocomplete [control]="form.get('contactUid')" [config]="{
                label: 'Contacto',
                placeholder: 'Buscar o crear contacto...',
                options: contacts,
                onChange: onContactChange.bind(this),
                allowCustomValues: true,
                customValueLabel: 'Crear nuevo contacto'
              }">
            </app-autocomplete>

            <app-autocomplete *ngIf="centers && centers.length > 0" [control]="form.get('centerUid')" [config]="{
                label: 'Centro',
                placeholder: 'Seleccionar centro...',
                options: centers
              }">
            </app-autocomplete>
          </mat-card-content>
        </mat-card>

        <mat-card appearance="outlined" class="tf-card">
          <mat-card-content>
            <div class="tf-section-header">
              <h6 class="tf-section-title">Datos del presupuesto</h6>
            </div>

            <app-field [control]="form.get('preInvoiceNumber')" [config]="{ label: 'Número de presupuesto', type: 'text' }"></app-field>

            <div class="pf-grid-2">
              <app-date [control]="form.get('invoiceRelease')" [config]="{ label: 'Fecha creación' }"></app-date>
              <app-date [control]="form.get('invoiceExpiration')" [config]="{ label: 'Fecha expiración' }"></app-date>
              <p class="cf-field__error pf-inline-error pf-grid-2__full" *ngIf="expirationBeforeRelease">La fecha de expiración no puede ser anterior a la de creación.</p>
            </div>

            <app-field *ngIf="form.get('applyKm').value" [control]="form.get('numberKilometers')" [config]="{ label: 'Número de kilómetros', type: 'number' }"></app-field>
          </mat-card-content>
        </mat-card>
      </div>

      <mat-card appearance="outlined" class="tf-card mb-3">
        <mat-card-content>
          <div class="tf-section-header ef-section__head--wrap">
            <h6 class="tf-section-title">Conceptos</h6>
            <span class="ef-section__badge" *ngIf="items.length">{{ items.length }}</span>
            <div class="ef-section__head-extra">
              <mat-checkbox formControlName="applyDiscount" class="ef-head-check">Descuento</mat-checkbox>
              <mat-checkbox formControlName="isMeasurable" class="ef-head-check">Medidas</mat-checkbox>
              <button mat-stroked-button type="button" (click)="addTitle()" class="ef-btn-add-line">
                <mat-icon>title</mat-icon> Título
              </button>
              <button mat-flat-button type="button" (click)="addLine()" class="ef-btn-add-line ef-btn-add-line--primary">
                <mat-icon>add</mat-icon> Línea
              </button>
            </div>
          </div>

          <div *ngIf="items.length === 0" class="ef-empty-lines" [class.pf-empty-lines--invalid]="submitted">
            <mat-icon>inbox</mat-icon>
            <p>Sin conceptos. Pulsa "Línea" para comenzar.</p>
          </div>

          <ng-container *ngIf="items.length > 0">
            <div class="lines-scroll" (scroll)="onLinesScroll($event)">
              <div formArrayName="items" cdkDropList (cdkDropListDropped)="dropLine($event)" class="lines-container p-2">

                  <div *ngFor="let line of visibleItems; let i = index; trackBy: trackByIndex"
                    [formGroupName]="i" cdkDrag
                    class="line-row line-card p-1 mb-1 border rounded">

                    <ng-container *ngIf="line.get('type').value === 'title'">
                      <div class="line-flex">
                        <div class="drag" cdkDragHandle><mat-icon>drag_handle</mat-icon></div>
                        <div class="grow">
                          <app-field [control]="line.get('title')" [config]="{ label: 'Título', type: 'text' }"></app-field>
                        </div>
                        <div class="end">
                          <app-button icon="delete" variant="danger" className="btn-empty" (click)="removeLine(i)"></app-button>
                        </div>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="line.get('type').value === 'line'">
                      <div class="line-flex">
                        <div class="drag" cdkDragHandle><mat-icon>drag_handle</mat-icon></div>

                        <div class="w-unit" [class.d-none]="!form.get('isMeasurable').value">
                          <app-autocomplete [control]="line.get('masterUnitMeasurableUid')" [config]="{
                            label: 'Unidad', placeholder: 'Seleccionar unidad...', options: unitMeasurable }">
                          </app-autocomplete>
                        </div>

                        <div class="w-qmeas" [class.d-none]="!form.get('isMeasurable').value">
                          <app-field [control]="line.get('quantityMeasurable')" [config]="{ label: 'Cant.', type: 'number' }"></app-field>
                        </div>

                        <div class="grow concept">
                          <app-autocomplete [control]="line.get('conceptUid')" [config]="{
                            label: 'Concepto', placeholder: 'Buscar concepto...', options: concepts,
                            onChange: onConceptChange.bind(this, line), onBlur: onConceptChange.bind(this, line) }">
                          </app-autocomplete>
                        </div>

                        <div class="w-qty">
                          <app-field [control]="line.get('quantity')" [config]="{ label: 'Cantidad', type: 'number' }"></app-field>
                        </div>

                        <div class="w-price">
                          <app-field [control]="line.get('price')" [config]="{ label: 'Precio', type: 'number' }"></app-field>
                        </div>

                        <div class="w-disc" [class.d-none]="!form.get('applyDiscount').value">
                          <app-field [control]="line.get('discount')" [config]="{ label: 'Dto.(%)', type: 'number' }"></app-field>
                        </div>

                        <div class="grow taxes">
                          <app-multi-select-autocomplete [control]="line.get('tax')" [config]="{
                            label: 'Impuestos', placeholder: 'Buscar impuesto...', options: taxes,
                            groupBy: 'group', onChange: handleTaxChange, onFocus: handleTaxFocus, lineIndex: i }">
                          </app-multi-select-autocomplete>
                        </div>

                        <div class="end">
                          <span class="ef-line-total">{{ lineTotals[i] | number:'1.2-2' }}€</span>
                          <app-button icon="delete" variant="danger" className="btn-empty" (click)="removeLine(i)"></app-button>
                        </div>
                      </div>
                    </ng-container>

                  </div>

              </div>
            </div>

            <div class="cf-total-cards pf-totals">
              <div class="cf-total-card">
                <p class="label">Subtotal <strong>{{ subtotal | number:'1.2-2' }} €</strong></p>
              </div>
              <div class="cf-total-card">
                <p class="label">{{ taxesLabel }} <strong>{{ taxesTotal | number:'1.2-2' }} €</strong></p>
              </div>
              <div class="cf-total-card" *ngIf="retentionsTotal !== 0">
                <p class="label">Retención <strong>{{ retentionsTotal | number:'1.2-2' }} €</strong></p>
              </div>
              <div class="cf-total-card cf-total-card--highlight">
                <p class="label">Total <strong>{{ total | number:'1.2-2' }} €</strong></p>
              </div>
            </div>
          </ng-container>

        </mat-card-content>
      </mat-card>

      <div class="pf-side-by-side">
        <mat-card appearance="outlined" class="tf-card">
          <mat-card-content>
            <div class="tf-section-header">
              <h6 class="tf-section-title">Cobro</h6>
            </div>

            <app-autocomplete [control]="form.get('payMethodUid')" [config]="{
              label: 'Tipo de cobro', placeholder: 'Seleccionar tipo cobro...',
              options: payMethods, onChange: onPaymethodChange.bind(this) }">
            </app-autocomplete>

            <ng-container *ngIf="isBankAccountPayment()">
              <app-autocomplete [control]="form.get('bankAccountUid')" [config]="{
                label: 'Cuenta bancaria', placeholder: 'Seleccionar cuenta...', options: bankAccounts, autoSelectSingle: true }">
              </app-autocomplete>
            </ng-container>

            <ng-container *ngIf="isCashRegisterPayment()">
              <app-autocomplete [control]="form.get('cashRegisterUid')" [config]="{
                label: 'Caja/Efectivo', placeholder: 'Seleccionar caja...', options: cashRegisters, autoSelectSingle: true }">
              </app-autocomplete>
            </ng-container>

            <ng-container *ngIf="isPartnerPayment()">
              <app-autocomplete [control]="form.get('partnerUid')" [config]="{
                label: 'Socio', placeholder: 'Seleccionar socio...', options: partners, autoSelectSingle: true }">
              </app-autocomplete>
            </ng-container>

            <mat-checkbox formControlName="useDeliverAddress" (change)="toggleUseDeliverAddress($event.checked)">
              ¿Usar domicilio de entrega?
            </mat-checkbox>

          </mat-card-content>
        </mat-card>

        <mat-card appearance="outlined" class="tf-card">
          <mat-card-content>
            <div class="tf-section-header">
              <h6 class="tf-section-title">Categorización</h6>
            </div>

            <ng-container *ngIf="form.get('applyProject').value">
              <app-autocomplete [control]="form.get('projectUid')" [config]="{
            label: 'Proyecto', placeholder: 'Seleccionar proyecto...', options: projects }">
              </app-autocomplete>
            </ng-container>

            <app-autocomplete [control]="form.get('entranceAccount')" [config]="{
              label: 'Cuenta contable de ingreso', placeholder: 'Seleccionar cuenta…',
              options: accountingModels, displayField: 'name', valueField: 'id' }">
            </app-autocomplete>

            <app-textarea [control]="form.get('comments')" [config]="{ label: 'Comentarios', placeholder: 'Notas visibles en el presupuesto…', rows: 4 }"></app-textarea>

          </mat-card-content>
        </mat-card>
      </div>

    </form>
  </div>

  <div class="ef-loading" *ngIf="isLoading">
    <app-loading-state [message]="form?.get('uid')?.value || isEditRoute ? 'Cargando presupuesto…' : 'Preparando formulario…'"></app-loading-state>
  </div>

</div>
